import React, { useState } from "react";
import { useAlert } from "react-alert";
import { Modal } from "react-bootstrap";
import api from "../../api";

export const MonthlyModal = ({ showMonthly, handleCloseMonthly }) => {
  const alert = useAlert();
  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(false);

  const handleSubmit = async () => {
    try {
      if (!email) {
        alert.show("Please Enter Email.");
        return;
      }
      setLoader(true);

      const userCansubscribe = await checkCanSubscribe(email.toLowerCase());
      // console.log(userCansubscribe);
      if (userCansubscribe?.canSubscribe) {
        const payload = {
          email: email.toLowerCase(),
        };
        const stripeRes = await api.directPaySession(payload);
        // console.log(stripeRes);

        if (!stripeRes?.link) {
          throw new Error("Something went wrong");
        }

        window.open(stripeRes?.link, "_self");
      } else {
        if (userCansubscribe?.status) {
          if (userCansubscribe?.status.toLowerCase() == "active") {
            alert.show(
              "YOU ALREADY HAVE ACTIVE SUBSCRIPTION. PLEASE CREATE A TICKET TO CONTACT OUR SUPPORT TEAM.",
            );
          } else if (userCansubscribe?.status.toLowerCase() == "past_due")
            alert.show(
              `YOU ALREADY HAVE A SUBSCRIPTION, YOUR RECURRING PAYMENT IS PENDING.`,
            );
        } else {
          alert.show(`PLEASE CREATE A TICKET TO CONTACT OUR SUPPORT TEAM.`);
        }
      }
      setLoader(false);
    } catch (error) {
      alert.show(error?.message || "SOMETHING WENT WRONG.");
      setLoader(false);
    }
  };

  const checkCanSubscribe = async (emailcheck) => {
    try {
      const stripeRes = await api.getDirectCanSubscribe(emailcheck);
      return stripeRes;
    } catch (e) {
      alert.show(e.message);
      setLoader(false);
    }
  };

  return (
    <Modal show={showMonthly} onHide={handleCloseMonthly} centered>
      <Modal.Body>
        <div className="otpModalMain">
          <div className="closeIcon" onClick={handleCloseMonthly}>
            <i className="fa-solid fa-xmark" />
          </div>

          {/* <h2 className="title color-dark mb-0">Follow these steps.</h2>
      <div className="imgDiv">
        <img className='img-fluid' src={monthlyGroup} alt="" />
      </div> */}
          <h4 className=" color-dark mb-0 mt-4 text-center">
            {/* MONTHLY GROUP DETAILS */}
            Want to Join Monthly group?
          </h4>

          <div className="monthlySubsM">
            <div className="form-group my-4">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Email..."
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="text-center">
              {/* <h3 className="text-dark desc1 my-3">
              Want to Join Monthly group?
            </h3> */}
              {/* <Link to="/signup" className="themeBtn">
              Register
            </Link> */}
              {loader ? (
                <button className="themeBtn mx-auto" disabled={loader}>
                  <i
                    className="fa fa-spinner fa-pulse mx-2 mb-1"
                    style={{ position: "relative", top: "-0px" }}
                  ></i>
                  Register
                </button>
              ) : (
                <button
                  className="themeBtn mx-auto"
                  onClick={handleSubmit}
                  disabled={loader}
                >
                  Register
                </button>
              )}
            </div>
          </div>

          <div className="homeVideoM py-4">
            <iframe
              className="w-100"
              width="560"
              height="315"
              src="https://www.youtube.com/embed/k4o-lZiugLs?si=Geh7pJL4z3_R2iUv"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
